import { useCallback } from 'react';
import { TFilter, TModifier } from 'shared/types/filters';
import { useAppDispatch } from './useAppDispatch';
import { setJsonQuery } from 'shared/slices/jsonQuery';
import { modifyJsonQuery } from 'shared/utils/jsonQuery';
import { useSelector } from 'react-redux';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { updateSearchMeta } from 'shared/thunks/searchMeta';
import { applyFilters } from 'shared/thunks/filters';
import { setSearchMetaTooltipAvailable, updateLastAppliedFilter } from 'shared/slices/searchMetaTooltip';

export const useFilterChangeCallback = (filterKey: TFilter = 'advancedFilters') => {
  const dispatch = useAppDispatch();
  const jsonQuery = useSelector(selectJsonQuery);
  const {
    custom: { applyFilterAfterChange },
  } = useApplicationContext();

  return useCallback(
    async (...modifiers: [TModifier, ...TModifier[]]) => {
      const nextJsonQuery = modifyJsonQuery(jsonQuery, modifiers);

      dispatch(setJsonQuery(nextJsonQuery));

      await dispatch(updateSearchMeta());

      if (filterKey !== 'advancedFilters') {
        if (applyFilterAfterChange) {
          dispatch(applyFilters());

          return;
        }

        dispatch(setSearchMetaTooltipAvailable(true));
      }

      dispatch(updateLastAppliedFilter(filterKey));
    },
    [applyFilterAfterChange, dispatch, filterKey, jsonQuery],
  );
};
